import React from 'react'
import { Controller, Control, FieldErrors } from 'react-hook-form'
import BaseQuestion from '../base-question'
import s from '../styles.module.css'

interface TextQuestionProps {
  question: {
    id: number
    text: string
    isRequired?: boolean
    type: string
  }
  // RHF mode
  control?: Control<any>
  errors?: FieldErrors<any>
  // Zustand mode
  value?: string
  error?: string
  onChange?: (value: string) => void
  onBlur?: () => void
}

const TextQuestion: React.FC<TextQuestionProps> = ({
  question,
  control,
  errors,
  value,
  error,
  onChange,
  onBlur,
}) => {
  const isRHFMode = !!control && !!errors

  if (isRHFMode) {
    // RHF mode - use Controller
    return (
      <BaseQuestion question={question} control={control} errors={errors}>
        <Controller
          name={`question_${question.id}`}
          control={control}
          rules={{
            required: question.isRequired ? 'This field is required' : false,
          }}
          render={({ field }) => (
            <input type="text" className={s.textInput} {...field} />
          )}
        />
      </BaseQuestion>
    )
  } else {
    // Zustand mode - use direct props
    return (
      <BaseQuestion question={question} error={error}>
        <input
          type="text"
          className={s.textInput}
          value={value || ''}
          onChange={e => onChange?.(e.target.value)}
          onBlur={onBlur}
        />
      </BaseQuestion>
    )
  }
}

export default TextQuestion
